// components/templates/sections/TopBar.tsx
'use client';

import { useDesign } from "@/context/DesignContext";

interface TopBarProps {
  email: string;
  address: string;
  language?: string;
  design?: any; // optional, context will be used if not provided
}

export default function TopBar({ email, address, language = 'English', design: propDesign }: TopBarProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const topBarStyle: React.CSSProperties = {
    backgroundColor: design.colors.primary,
    color: design.colors.textLight,
    borderBottom: `1px solid ${design.colors.border}`,
    padding: '8px 0',
    fontSize: '14px',
  };

  const linkStyle = { color: design.colors.textLight, textDecoration: 'none' };

  return (
    <div style={topBarStyle.backgroundColor ? topBarStyle : { backgroundColor: '#333', color: '#fff', padding: '8px 0', fontSize: '14px' }}>
      <div className="container" style={{ maxWidth: design.spacing.containerMaxWidth, margin: '0 auto' }}>
        <div className="row" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="col-xl-8 col-md-12">
            <div className="list-info">
              <ul style={{ display: 'flex', gap: '20px', listStyle: 'none', margin: 0, padding: 0 }}>
                <li><i className="fa fa-envelope-open"></i> <a href={`mailto:${email}`} style={linkStyle}>{email}</a></li>
                <li><i className="fa fa-map"></i> {address}</li>
              </ul>
            </div>
          </div>
          <div className="col-xl-4 col-md-12">
            <div className="language" style={{ textAlign: 'right' }}>
              <i className="fa fa-globe"></i> {language} <i className="fa-solid fa-chevron-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}